import { Component, ViewChild } from '@angular/core';
import { Service } from '../service';
import { FCToasterService } from '../common/toaster/FCToasterService';
import { GridOptions, ICellRendererParams } from 'ag-grid-community';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { updateunitdetailsrequest } from '../common/models/updateunitdetailsRequest';
import { MatRadioButton } from '@angular/material/radio';
import { unitUpdateList } from '../common/models/unitUpdateList';
import { MasterDataService } from '../services/master-data.service';

@Component({
    selector: 'app-building-details-update',
    templateUrl: './building-details-update.component.html',
    styleUrls: ['./building-details-update.component.scss'],
    standalone: false
})
export class BuildingDetailsUpdateComponent {
  readonly buildingFieldMaxLength: Record<'buildingId' | 'buildingName' | 'address1' | 'city' | 'state' | 'postalCode', number> = {
    buildingId: 32,
    buildingName: 125,
    address1: 125,
    city: 64,
    state: 16,
    postalCode: 32
  };
  readonly restrictedBuildingFields: Array<'buildingName' | 'address1' | 'city' | 'state' | 'postalCode'> = ['buildingName', 'address1', 'city', 'state', 'postalCode'];
  txtBuildingSrch: string;
  gridOptions: GridOptions;
  rowData: any[];
  tempRowData: any[];
  columnDefs: any[] = [];
  selectedUnitsInfo: unitUpdateList[];
  updateunitdetailsreq: updateunitdetailsrequest;
  closeResult: string;
  deviceTypes: any[];
  gatewayTypesInfo: string = "";
  enableSave: boolean = false;
  rbSelectedOption: string = "1";
  enableBuildingDet: boolean = true;
  enableCPIBDeviceCol: boolean = false;
  isCheckAll = true;
  enableCheckAll = false;
  txtBuildingId: string = "";
  txtBuildingName: string = "";
  txtAddress1: string = "";
  txtCity: string = "";
  txtState: string = "";
  txtPostalCode: string = "";
  bulkUpdateOriginalValues: Record<'buildingId' | 'buildingName' | 'address1' | 'city' | 'state' | 'postalCode', string> = {
    buildingId: "",
    buildingName: "",
    address1: "",
    city: "",
    state: "",
    postalCode: ""
  };
  lblErrorBuildingId: string = "";
  hasPendingCellValidationError = false;
  
  constructor(private apiService: Service, private toastr: FCToasterService,
      private modalService: NgbModal, private masterDataService: MasterDataService) { }

  private isGridEditingEnabled(enableColumnEditing: boolean) {
    return enableColumnEditing && !this.isCheckAll;
  }

  private startsWithRestrictedCharacter(value: string) {
    return /^[=+\-@]/.test(value.trimStart());
  }

  private getInvalidBuildingFieldMessage(headerName: string) {
    return `${headerName} cannot start with =, +, - or @.`;
  }

  private normalizeBuildingSaveValue(value: string) {
    return value.replace(/\s*&\s*/g, ' and ').replace(/\s{2,}/g, ' ').trim();
  }

  private getNormalizedBuildingInfo(item: unitUpdateList) {
    return {
      ...item,
      buildingId: item.buildingId ? this.normalizeBuildingSaveValue(item.buildingId) : item.buildingId,
      buildingName: item.buildingName ? this.normalizeBuildingSaveValue(item.buildingName) : item.buildingName,
      address1: item.address1 ? this.normalizeBuildingSaveValue(item.address1) : item.address1,
      city: item.city ? this.normalizeBuildingSaveValue(item.city) : item.city,
      state: item.state ? this.normalizeBuildingSaveValue(item.state) : item.state,
      postalCode: item.postalCode ? this.normalizeBuildingSaveValue(item.postalCode) : item.postalCode
    };
  }

  private validateBulkUpdateBuildingFields(changedFields: Record<keyof typeof this.bulkUpdateOriginalValues, string>, updatedFieldNames: Array<keyof typeof this.bulkUpdateOriginalValues>) {
    const invalidField = updatedFieldNames.find((fieldName): fieldName is 'buildingId' | 'buildingName' | 'address1' | 'city' | 'state' | 'postalCode' => {
      
      return this.startsWithRestrictedCharacter(changedFields[fieldName]);
    });

    if (!invalidField) {
      return true;
    }

    const fieldLabels: Record<'buildingId' | 'buildingName' | 'address1' | 'city' | 'state' | 'postalCode', string> = {
      buildingId: 'Building Id',
      buildingName: 'Building Name',
      address1: 'Address',
      city: 'City',
      state: 'State',
      postalCode: 'Postal Code'
    };

    this.lblErrorBuildingId = this.getInvalidBuildingFieldMessage(fieldLabels[invalidField]);
    return false;
  }

  ngOnInit(
    @ViewChild('tabRadioGroup', { static: false }) tabRadioGroup: MatRadioButton

  ): void {
    this.gridOptions = {
      defaultColDef: { filter: false },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: false,
      rowSelection: 'multiple',
      paginationAutoPageSize: false,
      headerHeight: 40,
      rowHeight: 32
    }
    this.getDeviceTypes();
    this.selectedUnitsInfo = [];
    this.updateunitdetailsreq = new updateunitdetailsrequest();    
  }

  bindGridOnPageLoad() {
    this.columnDefs = [
      { headerName: "Unit Id", field: "unitId", sortable: true, minWidth: 140, flex: 1.4, tooltipField: "unitId", headerTooltip: "Unit Id", hide: "true" },
      { headerName: "Unit Number", field: "elevatorUnitNumber", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "elevatorUnitNumber", headerTooltip: "Unit Number" },
      this.createBuildingTextColumn("Building Id", "buildingId", 170),
      { headerName: "G3MS Building Id", field: "g3MSBuildingId", sortable: true, minWidth: 170, flex: 1.7, resizable: true, tooltipField: "g3MSBuildingId", headerTooltip: "G3MS Building Id" },
      {
        headerName: "CPIB DeviceType", sortable: true, minWidth: 270, flex: 2.7, resizable: true, headerTooltip: "CPIB DeviceType Id",
        field: "cpibDeviceTypeId",
        editable: () => this.isGridEditingEnabled(this.enableCPIBDeviceCol),
        singleClickEdit: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: this.deviceTypes.map((opt) => opt.key)
        },
        valueFormatter: (params: any) => {
          const found = this.deviceTypes.find((opt) => opt.key === params.value);
          return found ? found.value : params.value;
        }
        ,
        valueSetter: (params: any) => {
          const selValue = Number(params.newValue);
          if(selValue == 0){
            params.data[params.colDef.field] = params.oldValue;
            this.toastr.showWarning("CPIB Device Type cannot be --select--, Restoring previous selection");
            return false;
          }
          else if(selValue == 403 || selValue == 405){
            params.data[params.colDef.field] = params.oldValue;
            this.toastr.showWarning("Selected CPIB device type is no longer valid for update");
            return false;
          }
          else{
            params.data[params.colDef.field] = selValue;           
            return true; 
          }
        } 
      },
      {
        headerName: "G3MS CPIB DeviceType", sortable: true, minWidth: 270, flex: 2.7, resizable: true, headerTooltip: "G3MS CPIB DeviceType Id",
        field: "g3MSCpibDeviceTypeId",
        editable: false,
        cellEditor: 'select',
        cellEditorParams: {
          values: this.deviceTypes.map((opt) => opt.key)
        },
        valueFormatter: (params: any) => {
          const found = this.deviceTypes.find((opt) => opt.key === params.value);
          return found ? found.value : params.value;
        }
      },
      this.createBuildingTextColumn("Building Name", "buildingName", 300),
      this.createBuildingTextColumn("Building Address", "address1", 350),
      this.createBuildingTextColumn("City", "city", 180),
      this.createBuildingTextColumn("State", "state", 180),
      this.createBuildingTextColumn("Postal Code", "postalCode", 180),
      { headerName: "MAC Address/Serial Number", field: "gatewayMacAddress", sortable: true, minWidth: 270, flex: 2.7, resizable: true, tooltipField: "gatewayMacAddress", headerTooltip: "MAC Address/Serial Number" },
      { headerName: "Gateway Type", field: "gatewayType", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "gatewayType", headerTooltip: "Gateway Type" },
      { headerName: "CPIB2 MAC Address", field: "cpibMacAddress", sortable: true, minWidth: 220, flex: 2.2, tooltipField: "cpibMacAddress", headerTooltip: "CPIB2 MAC Address" },
      { headerName: "CP-ID/UUID", field: "cpibUUID", sortable: true, minWidth: 250, flex: 2.5, resizable: true, tooltipField: "cpibUUID", headerTooltip: "CP-ID/UUID" },
      { headerName: "Created By", field: "createdBy", sortable: true, minWidth: 170, flex: 1.7, tooltipField: "createdBy", headerTooltip: "Created By" },
      { headerName: "Created Date", field: "createdDate", sortable: true, minWidth: 220, flex: 2.2, tooltipField: "createdDate", headerTooltip: "Created Date" },
    ]
    this.rowData = [];
  }

  private createBuildingTextColumn(headerName: string, field: keyof typeof this.buildingFieldMaxLength, width: number) {
    return {
      headerName: headerName,
      field: field,
      sortable: true,
      minWidth: width,
      flex: Math.round((width / 100) * 10) / 10,
      resizable: true,
      tooltipField: field,
      headerTooltip: headerName,
      editable: () => this.isGridEditingEnabled(this.enableBuildingDet),
      cellEditor: 'agTextCellEditor',
      cellEditorParams: {
        maxLength: this.buildingFieldMaxLength[field]
      },
      valueSetter: (params: any) => this.setBuildingTextValue(params, field)
    };
  }

  private setBuildingTextValue(params: any, field: keyof typeof this.buildingFieldMaxLength) {
    const newValue = params.newValue == null ? "" : params.newValue.toString();
    const maxLength = this.buildingFieldMaxLength[field];

    if (newValue.length > maxLength) {
      this.toastr.showWarning(`${params.colDef.headerName} cannot exceed ${maxLength} characters`);
      params.data[params.colDef.field] = params.oldValue;
      return false;
    }

    if (this.startsWithRestrictedCharacter(newValue)) {
      this.toastr.showWarning(this.getInvalidBuildingFieldMessage(params.colDef.headerName));
      params.data[params.colDef.field] = params.oldValue;
      return false;
    }

    params.data[params.colDef.field] = newValue;
    return true;
  }

  getDeviceTypes() {
    this.masterDataService
      .getDeviceTypes_Provisioning(true)
      .subscribe((data: any) => {
        this.deviceTypes = [{
          value: "-- select --",
          key: 0,
          elevatorTypeId: 1
        }];
        data.filter(t=>t.elevatorTypeId === 1).map(item => {
          this.deviceTypes.push(
            {
              value: item.deviceType,
              key: item.deviceTypeId,
              elevatorTypeId: item.elevatorTypeId
            });
        });

        this.bindGridOnPageLoad();
      });
  }

  rbChange() {
    this.enableBuildingDet = this.rbSelectedOption == "1" ? true : false;
    this.enableCPIBDeviceCol = this.rbSelectedOption == "2" ? true : false;
    this.rowData = []; this.tempRowData = [];
    this.selectedUnitsInfo = [];
    this.bindGridOnPageLoad();
    this.isCheckAll = false;
  }

  private restorePreviousCellValue(params: any) {
    params.data[params.colDef.field] = params.oldValue;
    params.api.refreshCells({
      force: true,
      rowNodes: [params.node],
      columns: [params.colDef.field]
    });
  }

  onCellValueChanged(params: any) {
     this.hasPendingCellValidationError = false;

    if (this.enableBuildingDet && typeof params.newValue === 'string' && params.newValue.trim() === "") {
       this.hasPendingCellValidationError = true;
       this.restorePreviousCellValue(params);
       this.toastr.showWarning("BuildingId cannot be empty, Restoring previous value");
       return false;
    }

    const unitId = params.data['unitId'];

    const originalRow = this.tempRowData.find((opt) => opt.unitId === unitId);
    const fieldName = params.colDef.field as 'buildingId' | 'buildingName' | 'address1' | 'city' | 'state' | 'postalCode' | 'cpibDeviceTypeId';
    const getAddressValue = (row: any) => row?.address1 ?? "";
    const getFieldValue = (row: any, field: string) => {
      if (!row) {
        return "";
      }

      if (field === 'address1') {
        return getAddressValue(row);
      }

      return row[field] ?? "";
    };
    const removeTrackedFieldEntry = (item: unitUpdateList) => {
      if (item.unitId !== unitId) {
        return true;
      }

      if (fieldName === 'cpibDeviceTypeId') {
        return item.cpibDeviceTypeId === 0;
      }

      switch (fieldName) {
        case 'buildingId':
          return !item.buildingId;
        case 'buildingName':
          return !item.buildingName;
        case 'address1':
          return !item.address1;
        case 'city':
          return !item.city;
        case 'state':
          return !item.state;
        case 'postalCode':
          return !item.postalCode;
        default:
          return true;
      }
    };

    const originalValue = getFieldValue(originalRow, fieldName);
    const currentValue = getFieldValue(params.data, fieldName);
    const hasChanged = currentValue != originalValue;

    this.selectedUnitsInfo = this.selectedUnitsInfo.filter(removeTrackedFieldEntry);

    if (hasChanged) {
      const updatedUnit: unitUpdateList = {
        elevatorUnitNumber: params.data['elevatorUnitNumber'],
        unitId: unitId,
        cpibDeviceTypeId: 0,
        buildingId: "",
        buildingName: "",
        address1: "",
        city: "",
        state: "",
        postalCode: "",
        index: params.rowIndex
      };

      if (fieldName === 'cpibDeviceTypeId') {
        updatedUnit.cpibDeviceTypeId = params.data['cpibDeviceTypeId'];
      }
      else {
        switch (fieldName) {
          case 'buildingId':
            updatedUnit.buildingId = currentValue;
            break;
          case 'buildingName':
            updatedUnit.buildingName = currentValue;
            break;
          case 'address1':
            updatedUnit.address1 = currentValue;
            break;
          case 'city':
            updatedUnit.city = currentValue;
            break;
          case 'state':
            updatedUnit.state = currentValue;
            break;
          case 'postalCode':
            updatedUnit.postalCode = currentValue;
            break;
        }
      }

      this.selectedUnitsInfo.push(updatedUnit);
    }

    params.data.isEdited = this.selectedUnitsInfo.some((opt) => opt.unitId === unitId);

    this.refreshGrid();
    this.enableSave = this.selectedUnitsInfo.length > 0 ? true : false;
  }

  refreshGrid() {
    if (!this.gridApi) {
      return;
    }

    var p = {
      force: true
    };
    this.gridApi.refreshCells(p);
  }

  enableDisableSave(event) {
    this.enableSave = this.isCheckAll = event.currentTarget.checked;

    if (this.isCheckAll && this.gridApi) {
      this.gridApi.stopEditing();
    }

    this.refreshGrid();
  }

  private setBulkUpdateFormValues(source?: any) {
    this.txtBuildingId = source?.buildingId ?? "";
    this.txtBuildingName = source?.buildingName ?? "";
    this.txtAddress1 = source?.address1 ?? "";
    this.txtCity = source?.city ?? "";
    this.txtState = source?.state ?? "";
    this.txtPostalCode = source?.postalCode ?? "";
  }

  private syncBulkUpdateOriginalValues(source?: any) {
    this.bulkUpdateOriginalValues = {
      buildingId: source?.buildingId ?? "",
      buildingName: source?.buildingName ?? "",
      address1: source?.address1 ?? "",
      city: source?.city ?? "",
      state: source?.state ?? "",
      postalCode: source?.postalCode ?? ""
    };
  }

  private initializeBulkUpdateForm() {
    const firstRow = this.rowData != null && this.rowData.length > 0 ? this.rowData[0] : undefined;
    this.syncBulkUpdateOriginalValues(firstRow);
    this.setBulkUpdateFormValues(firstRow);
  }

  onKeyEnter() {
    this.getUnitBuildingNameSearch();
  }

  gridApi: any;
  onGridReady(params) {
    this.gridApi = params.api;
  }

  getUnitBuildingNameSearch() {
    this.selectedUnitsInfo = [];
    if (this.txtBuildingSrch != null && this.txtBuildingSrch != undefined && this.txtBuildingSrch.trim() != "") {
      this.apiService
        .getUnitBuildingDetails(this.txtBuildingSrch)
        .subscribe((data: any) => {
          if (data != null && data.length > 0) {
            this.gridApi.refreshCells({ force: true });
            this.rowData = data;
            this.tempRowData = structuredClone(this.rowData);
            this.enableCheckAll = true; 
            if(this.enableBuildingDet)
              this.isCheckAll = true;
          }
          else {
            this.rowData = [];
            this.toastr.showError("No records found for given Unit Number / Building Name / Building Id");
          }
        });      
    }
    else {
      this.toastr.showError("Please enter Unit Number / Building Name / Building Id");
    }
  }

  onResetFilters() {
    this.gatewayTypesInfo = ""; this.txtBuildingSrch = ""; this.rbSelectedOption = "1";this.txtBuildingId = "";
    this.txtBuildingName = ""; this.txtAddress1 = ""; this.txtCity = ""; this.txtState = ""; this.txtPostalCode = "";
    this.syncBulkUpdateOriginalValues();
    this.rowData = []; this.tempRowData = []; this.selectedUnitsInfo = [];    
    this.isCheckAll = false;this.enableCheckAll = false;this.enableSave = false;    
    this.hasPendingCellValidationError = false;
    this.clearErrorMessages();
  }

  clearErrorMessages() {
    this.lblErrorBuildingId = "";
  }

  hasGatewayAssociation(unitIds: number[]): boolean {
    const selectedUnitIds = new Set(unitIds.filter((unitId) => unitId != null));

    return this.rowData.some((row) => {
      const hasSelectedUnit = selectedUnitIds.has(row["unitId"]);
      const hasGatewayMacAddress = row["gatewayMacAddress"] != null && row["gatewayMacAddress"].toString().trim() !== "";
      const hasEPALGatewayMacAddress = row["ePALGatewayMacAddress"] != null && row["ePALGatewayMacAddress"].toString().trim() !== "";

      return hasSelectedUnit && (hasGatewayMacAddress || hasEPALGatewayMacAddress);
    });
  }

  onUpdateUnitInfo() {
    if (this.isCheckAll) {
      const bulkFieldNames: Array<keyof typeof this.bulkUpdateOriginalValues> = ['buildingId', 'buildingName', 'address1', 'city', 'state', 'postalCode'];
      const buildingId = this.txtBuildingId ? this.txtBuildingId.trim() : "";
      const buildingName = this.txtBuildingName ? this.txtBuildingName.trim() : "";
      const address1 = this.txtAddress1 ? this.txtAddress1.trim() : "";
      const city = this.txtCity ? this.txtCity.trim() : "";
      const state = this.txtState ? this.txtState.trim() : "";
      const postalCode = this.txtPostalCode ? this.txtPostalCode.trim() : "";
      const changedFields: Record<keyof typeof this.bulkUpdateOriginalValues, string> = {
        buildingId: buildingId,
        buildingName: buildingName,
        address1: address1,
        city: city,
        state: state,
        postalCode: postalCode
      };
      const updatedFieldNames = bulkFieldNames.filter((fieldName) => changedFields[fieldName] !== this.bulkUpdateOriginalValues[fieldName]);

      if (updatedFieldNames.length === 0) {
        this.lblErrorBuildingId = "Please update at least one field";
        return false;
      }

      if (!this.validateBulkUpdateBuildingFields(changedFields, updatedFieldNames)) {
        return false;
      }

      this.lblErrorBuildingId = "";
      var unitId = this.rowData[0]["unitId"];
      const bulkUpdateItem: any = {
        unitId: unitId,
        cpibDeviceTypeId: 0,
        elevatorUnitNumber: "",
        index: 0
      };

      updatedFieldNames.forEach((fieldName) => {
        bulkUpdateItem[fieldName] = changedFields[fieldName];
      });

      this.selectedUnitsInfo = [bulkUpdateItem as unitUpdateList];
    }

    if (this.selectedUnitsInfo.length > 0) {
      const mergedSelectedUnitsInfo = this.isCheckAll
        ? this.selectedUnitsInfo.map((item) => ({ ...item }))
        : Array.from(
            this.selectedUnitsInfo.reduce((accumulator, item) => {
              const mapKey = `${item.unitId ?? ''}_${item.elevatorUnitNumber ?? ''}`;
              const existingItem = accumulator.get(mapKey) || {
                unitId: item.unitId,
                elevatorUnitNumber: item.elevatorUnitNumber || "",
                cpibDeviceTypeId: null,
                buildingId: "",
                buildingName: "",
                address1: "",
                city: "",
                state: "",
                postalCode: "",
                index: item.index
              };

              if (item.cpibDeviceTypeId) {
                existingItem.cpibDeviceTypeId = item.cpibDeviceTypeId;
              }
              if (item.buildingId) {
                existingItem.buildingId = item.buildingId;
              }
              if (item.buildingName) {
                existingItem.buildingName = item.buildingName;
              }
              if (item.address1) {
                existingItem.address1 = item.address1;
              }
              if (item.city) {
                existingItem.city = item.city;
              }
              if (item.state) {
                existingItem.state = item.state;
              }
              if (item.postalCode) {
                existingItem.postalCode = item.postalCode;
              }

              accumulator.set(mapKey, existingItem as unitUpdateList);
              return accumulator;
            }, new Map<string, unitUpdateList>()).values()
          );

      this.selectedUnitsInfo = this.enableBuildingDet
        ? mergedSelectedUnitsInfo.map((item) => this.getNormalizedBuildingInfo(item))
        : mergedSelectedUnitsInfo;
      this.updateunitdetailsreq.bulkUpdate = this.isCheckAll;
      this.updateunitdetailsreq.updatedList = this.selectedUnitsInfo;
      this.apiService
        .updateUnitBuildingDetails(this.updateunitdetailsreq)
        .subscribe((data: any) => {
          if (data != null && data) {
            this.toastr.showSuccess((this.enableBuildingDet ? "Building Info" : "CPIB Device Type") + " updated successfully");
            this.modalService.dismissAll();
            this.getUnitBuildingNameSearch();
            this.selectedUnitsInfo = [];
            this.txtBuildingId = "";
            this.txtBuildingName = "";
            this.txtAddress1 = "";
            this.txtCity = "";
            this.txtState = "";
            this.txtPostalCode = "";
            this.syncBulkUpdateOriginalValues();
            this.enableSave = false;
          }
          else {
            this.rowData = [];
            this.toastr.showError((this.enableBuildingDet ? "Building Info" : "CPIB Device Type") + " update failed");
          }
        });
    }
    else {
      this.toastr.showError("Please Update " + (this.enableBuildingDet ? " Building Info" : "CPIB Device Type") + " for any unit");
    }
  }
  
  open(content) {
    this.lblErrorBuildingId = "";
    this.gridApi.stopEditing();
    setTimeout(() => {
      if (this.hasPendingCellValidationError) {
        this.hasPendingCellValidationError = false;
        return;
      }

      if (this.selectedUnitsInfo.length == 0 && !this.isCheckAll) {
        this.toastr.showError("Please Update " + (this.enableBuildingDet ? " Building Details" : "CPIB Device Type") + " for any unit");
      }
      else {
        this.gatewayTypesInfo = "";
        if (this.enableCPIBDeviceCol) {
          this.setBulkUpdateFormValues();
          this.syncBulkUpdateOriginalValues();
          this.selectedUnitsInfo.forEach(element => {
            this.gatewayTypesInfo += (this.gatewayTypesInfo.length > 0 ? " \n " : "") + (element.elevatorUnitNumber + " - " + this.deviceTypes.find(d => d.key === element.cpibDeviceTypeId).value);
          });
        }
        else if (this.enableBuildingDet) {
          if (this.isCheckAll) {
            this.initializeBulkUpdateForm();
          }
          else {
            this.setBulkUpdateFormValues();
            this.syncBulkUpdateOriginalValues();
          }
          const groupedUnitUpdates = new Map<string, string[]>();

          this.selectedUnitsInfo.forEach(element => {
            const unitNumber = element.elevatorUnitNumber || "";
            const fieldUpdates: string[] = [];

            if (element.buildingId) {
              fieldUpdates.push("Building Id - " + element.buildingId);
            }
            if (element.buildingName) {
              fieldUpdates.push("Building Name - " + element.buildingName);
            }
            if (element.address1) {
              fieldUpdates.push("Address - " + element.address1);
            }
            if (element.city) {
              fieldUpdates.push("City - " + element.city);
            }
            if (element.state) {
              fieldUpdates.push("State - " + element.state);
            }
            if (element.postalCode) {
              fieldUpdates.push("Postal Code - " + element.postalCode);
            }

            if (!groupedUnitUpdates.has(unitNumber)) {
              groupedUnitUpdates.set(unitNumber, []);
            }

            const unitUpdates = groupedUnitUpdates.get(unitNumber);
            if (unitUpdates) {
              unitUpdates.push(...fieldUpdates);
            }
          });

          this.gatewayTypesInfo = Array.from(groupedUnitUpdates.entries())
            .map(([unitNumber, updates]) => "<b>" + unitNumber + "</b>: " + updates.join(", "))
            .join("<br>");
        }
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    }, 500);
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}